/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValidatorRestoreDto } from '../models/ValidatorRestoreDto';
import type { ValidatorRestoreResponseDto } from '../models/ValidatorRestoreResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValidatorRestoreControllerService {

    /**
     * @param name
     * @returns ValidatorRestoreResponseDto OK
     * @throws ApiError
     */
    public static getRestoreJob(
        name: string,
    ): CancelablePromise<ValidatorRestoreResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validators/{name}/restore',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @param requestBody
     * @returns ValidatorRestoreResponseDto Created
     * @throws ApiError
     */
    public static createRestoreJob(
        name: string,
        requestBody: ValidatorRestoreDto,
    ): CancelablePromise<ValidatorRestoreResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/validators/{name}/restore',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

}
